var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfinity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 -9.5 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "infinity") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vivid.JS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vivid-Icons",
    transform: "translate(-744.000000, -262.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(37.000000, 169.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "infinity",
    transform: "translate(702.000000, 78.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 15.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.952,19 C26.1276534,19.0032293 23.4641032,17.6862517 21.752,15.44 L16.288,10 L21.757,4.56 C24.3055147,1.16357777 28.8771268,0.00338606597 32.7368197,1.77352223 C36.5965125,3.54365839 38.6999612,7.7651731 37.7887545,11.9124992 C36.8775478,16.0598252 33.1982329,19.0108122 28.952,19 Z M28.852,4.6 C27.1341069,4.59401992 25.5099216,5.38248806 24.452,6.736 L21.112,10 L24.454,13.264 C25.5118239,14.6176328 27.1360723,15.4061316 28.854,15.4 C30.7832342,15.3996428 32.5657296,14.3700785 33.5300373,12.699134 C34.494345,11.0281895 34.4939638,8.96972114 33.5290373,7.29913394 C32.5641108,5.62854674 30.7812342,4.59964269 28.852,4.6 Z",
    fill: "#0C0058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.243,15.44 C13.907031,18.5187667 9.86628593,19.7625063 6.20336868,18.5301943 C2.54045143,17.2978824 0.0731743396,13.8646547 0.0731743396,10 C0.0731743396,6.13534534 2.54045143,2.70211764 6.20336868,1.46980566 C9.86628593,0.237493682 13.907031,1.48123332 16.243,4.56 L21.712,10 L16.243,15.44 Z M13.543,6.74 C12.4850784,5.38648806 10.8608931,4.59801992 9.143,4.604 C6.16066235,4.604 3.743,7.02166235 3.743,10.004 C3.743,12.9863376 6.16066235,15.404 9.143,15.404 C10.8609277,15.4101316 12.4851761,14.6216328 13.543,13.268 L16.888,10 L13.543,6.74 Z",
    fill: "#FF6E6E"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinity);
export default __webpack_public_path__ + "static/media/infinity.caba0771aa131ff211ffbd90df43e6b6.svg";
export { ForwardRef as ReactComponent };